import React, { useContext, useEffect, useState } from "react";
import { handleApiErrors, InputType, validationRegex, } from "../../Utils/Utils";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CoordinatorSidebar from "../CoordinatorSidebar/CoordinatorSidebar";
import CoordinatorNavbar from "../CoordinatorNavbar/CoordinatorNavbar";
import DataProvider from "../../Utils/DataProvider";
import { useNavigate, useLocation } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { toast } from "react-toastify";
import CustomDropDownReward from "../../Components/Reusable/CustomDropDownReward";
import Dropdowncoordinator from "../../Components/Reusable/Dropdowncoordinator";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import { RotatingLines } from "react-loader-spinner";
import { AuthContext } from "../../Context/authContext";
import SessionManager from "../../Utils/Session";

const BankDetails = ({ show }) => {
  const { coordinator } = useContext(AuthContext)
  const [bankdetails, setBankdetails] = useState(coordinator?.bankDetails || {});
  const [uploadedDocuments, setUploadedDocuments] = useState(Array());
  const [loading, setLoading] = useState(false);
  const [selectedAccountType, setSelectedAccountType] = useState(null);
  const navigate = useNavigate();
  const schema = yup.object().shape({
    accountholdername: validationRegex.required,
    accountnumber: validationRegex.accountNumber,
    confirmaccountnumber: validationRegex.confirmaccountnumber,
    branch: validationRegex.required,
    ifsccode: validationRegex.ifscCode,
    accounttype: validationRegex.required,
    cancelledcheque: validationRegex.required,
    pannumber: validationRegex.pannumber,
  });

  const { register: registerUpdate, handleSubmit: handleSubmitUpdate, setValue: setValuesupdate, formState: { errors: errorsUpdate }, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      accountholdername: coordinator?.bankDetails?.accountHolderName || "",
      accountnumber: coordinator?.bankDetails?.accountNumber || "",
      confirmaccountnumber: coordinator?.bankDetails?.accountNumber || "",
      branch: coordinator?.bankDetails?.branch || "",
      ifsccode: coordinator?.bankDetails?.ifscCode || "",
      accounttype: coordinator?.bankDetails?.accountType || "",
      cancelledcheque: coordinator?.bankDetails?.cancelledChequeImage || "",
      pannumber: coordinator?.bankDetails?.panNumber || "",

    },
  });
  useEffect(() => {
    if (coordinator?.bankDetails?.accountType) {
      // Set the selected account type when coordinator data is available
      setSelectedAccountType({
        value: coordinator.bankDetails.accountType,
        label: coordinator.bankDetails.accountType
      });
      setValuesupdate("accounttype", coordinator.bankDetails.accountType);
    }
  }, [coordinator?.bankDetails]);
  useEffect(() => {
    if (coordinator.bankDetails) {
      EditData();
    }
  }, [coordinator.bankDetails, setValuesupdate,]);


  const EditData = () => {
    if (coordinator?.bankDetails) {
      setValuesupdate("accountholdername", coordinator?.bankDetails?.accountHolderName || "");
      setValuesupdate("accountnumber", coordinator?.bankDetails?.accountNumber || "");
      setValuesupdate("confirmaccountnumber", coordinator?.bankDetails?.accountNumber || "");
      setValuesupdate("branch", coordinator?.bankDetails?.branch || "");
      setValuesupdate("ifsccode", coordinator?.bankDetails?.ifscCode || "");
      setValuesupdate("accounttype", coordinator?.bankDetails?.accountType || "");
      setValuesupdate("pannumber", coordinator?.bankDetails?.panNumber || "");
      setValuesupdate("cancelledcheque", coordinator?.bankDetails?.cancelledChequeImage || []);
      setUploadedDocuments(coordinator?.bankDetails?.cancelledChequeImage || uploadedDocuments)
    }
  }
  const handleUpdateBankDetails = async (data) => {
    setLoading(true);
    try {
      const response = await CoordinatorApiServices.addBankDetails(
        data.accountholdername,
        data.accountnumber,
        data.accounttype,
        data.branch,
        uploadedDocuments,
        data.confirmaccountnumber,
        data.ifsccode,
        data.pannumber,
      );

      toast.success(response.message);
      EditData()
      SessionManager.shared.getCoordinatorData()
      setLoading(false)

    } catch (error) {
      // Handle API errors
      setLoading(false);
      handleApiErrors(error);
    }
  };
  return (
    <div className="d-flex">
      <CoordinatorSidebar />
      <div className="mainLayout-content">
        <CoordinatorNavbar />
        <div className="main_content_two contentSection sectiontwo scroll_bar cofocus">
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="black sub-large-text-one fw-700 mb-0">Update Bank Details</h1>
          </div>
          <form onSubmit={handleSubmitUpdate(handleUpdateBankDetails)}>
            <div className="row profile_inputs w-100">
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Account Holder Name"
                  placeholder="Enter Account Holder Name"
                  additionalClasses="profile_edit"
                  labelClass="TextInput"
                  name="accountholdername"
                  id="accountholdername"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={registerUpdate}
                  showError={errorsUpdate?.accountholdername}
                  errorMessage={errorsUpdate?.accountholdername?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Account Number"
                  labelClass="TextInput"
                  inputType={InputType.number}
                  id="accountnumber"
                  name="accountnumber"
                  placeholder="Enter Account Number"
                  additionalClasses="profile_edit"
                  showMandatory={true}
                  register={registerUpdate}
                  showError={errorsUpdate?.accountnumber}
                  errorMessage={errorsUpdate?.accountnumber?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Confirm Account Number"
                  inputType={InputType.text}
                  id="confirmaccountnumber"
                  name="confirmaccountnumber"
                  placeholder="Enter Account Number"
                  showMandatory={true}
                  additionalClasses="profile_edit"
                  labelClass="TextInput"
                  register={registerUpdate}
                  showError={errorsUpdate?.confirmaccountnumber}
                  errorMessage={errorsUpdate?.confirmaccountnumber?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="Branch"
                  placeholder="Enter Branch"
                  inputType={InputType.text}
                  showMandatory={true}
                  labelClass="TextInput"
                  name="branch"
                  id="branch"
                  additionalClasses="profile_edit"
                  register={registerUpdate}
                  showError={errorsUpdate?.branch}
                  errorMessage={errorsUpdate?.branch?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="IFSC Code"
                  placeholder="Enter IFSC Code"
                  inputType={InputType.text}
                  additionalClasses="profile_edit"
                  showMandatory={true}
                  name="ifsccode"
                  id="ifsccode"
                  labelClass="TextInput"
                  register={registerUpdate}
                  showError={errorsUpdate?.ifsccode}
                  errorMessage={errorsUpdate?.ifsccode?.message}
                />
              </div>
              <div className="col-md-6">
                <Dropdowncoordinator
                  labelTitle="Account Type"
                  placeholder="Select Type"
                  inputType={InputType.text}
                  showMandatory={true}
                  labelclass="TextDropdown"
                  name="accounttype"
                  id="accounttype"
                  additionalclass="dropdownaccount"
                  register={registerUpdate}
                  setValue={setValuesupdate}
                  showError={errorsUpdate?.accounttype}
                  errorMessage={errorsUpdate?.accounttype?.message}
                  options={DataProvider.accountType}
                  value={selectedAccountType} // Use value instead of defaultValue
                  onChange={(option) => {
                    setSelectedAccountType(option);
                    setValuesupdate("accounttype", option.value);
                  }}
                />

              </div>
              <div className="col-md-6 mb-3">
                <label className="TextInput mb-2">Upload Cancelled Cheque<span className="danger small-text fw-400 mt-1">*(Extension: jpg. jpeg.webp)</span></label>
                <div className="position-relative select_file ">
                  <input className="choose-file"
                    type="file"
                    name="cancelledcheque"
                    accept="image/jpeg, image/jpg, image/webp"
                    {...registerUpdate("cancelledcheque")}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const file = e.target.files[0];
                        const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                        if (!validTypes.includes(file.type)) {
                          toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                          e.target.value = null; // Clear the input value
                        } else {
                          setUploadedDocuments(file);
                        }
                      }
                    }}
                  />

                </div>
                {coordinator?.bankDetails?.cancelledChequeImage && (
                  <p className="text-success fs-14 fw-400 my-1">Selected file: {coordinator?.bankDetails?.cancelledChequeImage}</p>
                )}
                {errorsUpdate.cancelledcheque && (
                  <p className="danger fs-14 fw-400 my-1">{errorsUpdate.cancelledcheque.message}</p>
                )}
              </div>
              <div className="col-md-6">
                <CustomTextFieldTwo
                  labelTitle="PAN No."
                  placeholder="Enter PAN No."
                  inputType={InputType.text}
                  showMandatory={true}
                  additionalClasses="profile_edit"
                  labelClass="TextInput"
                  name="pannumber"
                  id="pannumber"
                  register={registerUpdate}
                  showError={errorsUpdate?.pannumber}
                  errorMessage={errorsUpdate?.pannumber?.message}
                />
              </div>
              <div className="d-flex justify-content-end  mt-5 chnagebtnrespo buttoninresponsive">
                {loading ? (
                  <div className="text-center d-flex justify-content-center">
                    <RotatingLines
                      height="30"
                      width="30"
                      strokeColor="#F6821F"
                    />
                  </div>
                ) : (
                  <SubmitButtonTwo title={"Submit"} className="Changebtn" onclick={handleSubmitUpdate(handleUpdateBankDetails)}
                  />
                )}
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default BankDetails;

